import { ReactComponent as StarIcon } from './star.svg';

export default StarIcon;
